import { render, staticRenderFns } from "./BACnetIntegration.vue?vue&type=template&id=4a9f8231&scoped=true&"
import script from "./BACnetIntegration.vue?vue&type=script&lang=ts&"
export * from "./BACnetIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f8231",
  null
  
)

export default component.exports